import React, { Component } from "react";
import { Modal, Form, Input, FormInstance } from "antd";

interface FormProps {
    data: any
    visible: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

class RemarkForm extends Component<FormProps> {
    
    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    render () {

        const { 
            visible, onCancel, onCreate, data,
         } = this.props;
        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 16 },
        };

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                title='添加备注'
                okText='保存'
                cancelText='取消'
                onCancel={onCancel}
                onOk={
                    () => {
                        this.formRelf.current!.validateFields().then(values => {
                            onCreate(values);
                        }).catch(info => {
                            console.log('Valide Failed:', info);
                        })
                    }
                }
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    initialValues={{
                        remark: data.remark,
                    }}
                    >
                    <Form.Item label='备注' name="remark" rules={[{required: true}]}>
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default RemarkForm